module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNvcnQ8L3RpdGxlPjxwYXRoIGQ9Ik03Ljg1LDQuMTVhLjQ4LjQ4LDAsMCwwLS43LDBsLTMsM2EuNDkuNDksMCwwLDAsLjcuN0w3LDUuNzFWMTkuNWEuNS41LDAsMCwwLDEsMFY1LjcxbDIuMTUsMi4xNGEuNDguNDgsMCwwLDAsLjcsMCwuNDguNDgsMCwwLDAsMC0uN1oiLz48cGF0aCBkPSJNMTkuODUsMTYuMjFhLjQ4LjQ4LDAsMCwwLS43LDBMMTcsMTguMzVWNC41YS41LjUsMCwwLDAtMSwwVjE4LjM1bC0yLjE1LTIuMTRhLjQ5LjQ5LDAsMCwwLS43LjdsMywzYS40OC40OCwwLDAsMCwuNywwbDMtM0EuNDguNDgsMCwwLDAsMTkuODUsMTYuMjFaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/sort_black.svg
// module id = 164
// module chunks = 1